import React, { useState, useEffect,Fragment } from 'react';
import {
    makeStyles,
    withStyles,
    Typography,
    Slide as MUISlide,
    Dialog,
    IconButton,
    DialogContent,
    DialogActions,
    Button,
    DialogTitle,
    Divider,
    DialogContentText,
    Card,
    CardContent,
    FormHelperText,
    Collapse,
    Menu,
    MenuList,
    ClickAwayListener,
    Grow,
    Popper,
    Grid,
    Box,
    Tab,
    Tabs,
    TextField
} from "@material-ui/core";
import CloseIcon from '@material-ui/icons/Close';
import { getTripDateFilterValues,numberFormatWithOutSpace,vehicleNumberDisplay,UPITest } from '../../../utils/utils';
import { connect } from "react-redux";
import * as logger from '../../../logger';
import { debounce } from 'lodash';
import {PaymentGateWayCss} from './PaymentGateWayCss';
import {
  PayDriver,
  PayDriverGeteWayIcon,
  PayShopGateWayIcon,
  PayWalletGeteWayIcon,
  PaySupplierGateWayIcon,
  RechargeFastagGateWayIcon,
  RechargeFuelCardWayIcon,
  PayShop,
  PaySupplier,
  PaymentRecieved,
  PaymentFastag,
  TransactionHistory,
  TransactionPending,
  PaySupplierBorder
} from '../TopCard/icons';
import { SelectedIcon } from '../../../components/icons';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import Checkbox from '@material-ui/core/Checkbox';
import PropTypes from 'prop-types';
import { GetPreferedPaymentModes,ValidateThePayment,getPaymentStatusV1,getPaymentInitiate } from '../../../store/actions/OnlinePaymentActionCreators';
import { NetBanking } from './GateWayIcons';
import UPIIcon from './upi.png';
import UPILogo from './UPILogo.png';
import UPIBanner from './upi-banner.png';
import PaymodeResponse from './response';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import { cashfreeProd,cashfreeSandbox } from 'cashfree-elementjs';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import Autocomplete from '@material-ui/lab/Autocomplete';
import VehicleNumberFormat from '../../pages/Expenses/VehicleNumberFormat';
import { sendError } from '../../../utils/utils';
import { getRechargeLink } from '../../../store/actions/fastagActionCreators';
import { rechargeFuelCard } from '../../../store/actions/vehicleActionCreator';
const BlueCheckbox = withStyles({
  root: {
    color: '#03c',
    '&$checked': {
      color:'#03c',
    },
  },
  checked: {},
})((props) => <Checkbox color="default" {...props} />);
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      style={{width:'100%'}}
      hidden={value !== index}
      id={`dweb-payment-gateway-payment-tabpanel-${index}`}
      aria-labelledby={`dweb-payment-gateway-payment-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3} width={'100%'} style={{paddingTop:0}}>
          {children}
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};
const PaymentTabs = withStyles({
  root: {
    //borderRight: '1px solid #e8e8e8',
    backgroundColor:'#eef1f6',
    paddingLeft:17,
    paddingTop:48,
    borderRadius:4
  },
  indicator: {
    backgroundColor: '#fff',
  },
})(Tabs);

const PaymentTab = withStyles((theme) => ({
  root: {
    textTransform: 'none',
    minWidth: 172,
    marginRight: theme.spacing(4),
    color:'#0b1323',
    fontWeight:600,
    fontSize:18,
    padding:16,
    borderRadius:4,
    '&:hover': {
      color: '#40a9ff',
      opacity: 1,
    },
    '&$selected': {
      backgroundColor:'#fff'
    },
    '&:focus': {
    },
    '& .MuiTab-wrapper':{
      display:'initial'
    }
  },
  selected: {},
}))((props) => <Tab {...props} />);
function a11yProps(index) {
  return {
    id: `dweb-payment-gateway-payment-tab-${index}`,
    'aria-controls': `dweb-payment-gateway-payment-tabpanel-${index}`,
  };
}
const DwebPaymentGateWayDialog = ({
    open, 
    onClose,
    onConfirm,
    onError,
    onFailure,
    onSuccess, 
    user,
    orderRequestData,
    cashFreeOrderData,
    dispatchFetchPaymentModes,
    dispatchValidatePayment,
    dispatchGetPaymentStatus,
    dispatchGetPaymentInitiate,
    dispatchFastagRechargetLink,
    dispatchRechargeFuelCard
}) => {
    let statusIntervel;
    let upiTimeOut;
    const [dialogOpen, setDialogOpen] = useState(open);
    const classes = PaymentGateWayCss();
    const [value, setValue] = React.useState(0);
    const [cashFreeOrderDataState, setCashFreeOrderDataState] = React.useState(cashFreeOrderData);
    const [orderRequestDataState, setOrderRequestDataState] = React.useState(orderRequestData);
    const [preferedPayments, setPreferedPayments] = React.useState(null);
    const [errorTxt,setErrorTxt] = useState(null);
    const [addUpiError,setAddUpiError] = useState(false);
    const [addUpiVerified,setAddUpiVerified] = useState(false);
    const [addUpiValue,setAddUpiValue] = useState(null);
    const [selectedUpiValue,setSelectedUpiValue] = useState(null);
    const [tokenData,setTokenData] = useState(null);
    const [netbankingValue,setNetbankingValue] = useState(null);
    const [configInfo, setConfigInfo] = useState({});
    useEffect(() => {

      if (user && user.configs && user.configs.online_payments_config) {
        setConfigInfo(user.configs.online_payments_config);
      } else {
        setConfigInfo({});
      }
  
    }, [user.configs]);
    const getTypeName = (type)=>{
      switch (type) {
          case "KHATA_SHOP":
              return "Shop";
          case "DRIVER":
              return "Driver";
          case "SUPPLIER":
              return "Supplier";
          case "FASTAG":
              return "Fastag";
          case "FUEL_CARD":
              return "Diesel Card"; 
          default:
              return null
        }
    }
    const getTypeTitle = (type)=>{
      switch (type) {
          case "KHATA_SHOP":
              return orderRequestDataState&&orderRequestDataState.selectedShop&&orderRequestDataState.selectedShop.name?orderRequestDataState.selectedShop.name:'Pay Shop';
          case "DRIVER":
              return orderRequestDataState&&orderRequestDataState.selectedDriver&&orderRequestDataState.selectedDriver.name?orderRequestDataState.selectedDriver.name:orderRequestDataState.selectedDriver&&orderRequestDataState.selectedDriver.driverName?orderRequestDataState.selectedDriver.driverName:'Pay Driver';
          case "SUPPLIER":
            return orderRequestDataState&&orderRequestDataState.selectedVendor&&orderRequestDataState.selectedVendor.name?orderRequestDataState.selectedVendor.name:'Pay Supplier';
          case "FASTAG":
              return "Fastag";
          case "FUEL_CARD":
              return "Diesel Card"; 
          default:
              return null
        }
    }
    const getTypeIcon = (type)=>{
      switch (type) {
          case "KHATA_SHOP":
              return <PayShopGateWayIcon  className={classes.icon} />;
          case "DRIVER":
              return <PayDriverGeteWayIcon className={classes.icon} />;  
          case "SUPPLIER":
            return <PaySupplierGateWayIcon className={classes.icon} />;
          case "FASTAG":
            return <RechargeFastagGateWayIcon className={classes.icon} />;  
          case "FUEL_CARD":
            return <RechargeFuelCardWayIcon className={classes.icon} />;  
          default:
              return null
        }
    }
    useEffect(() => {
      if(cashFreeOrderDataState && cashFreeOrderDataState.orderId){
        let reqData = {
          orderId: cashFreeOrderDataState.orderId,
          // orderId: "aa65f0dd-493c-43d3-81d7-d84a6f7c639c",
          paymentApps:[]
        }

        dispatchFetchPaymentModes(reqData, (response) => {
          if (response && response.status && response.status.code == 200 && response.response) {

            let paymentResponse = response.response

            // Pushing contents of preferredPaymentOptions into paymentOptions array, 
            // solve to reflect all the bank names in bank list autocomplete.
            if ( paymentResponse && paymentResponse.preferredPaymentOptions && paymentResponse.preferredPaymentOptions.length > 0 ) {

              // filtering out NET_BANKING from preferredPaymentOptions.
              for (let option of paymentResponse.preferredPaymentOptions) {        
                if (option && option.type == "NET_BANKING") {
                  paymentResponse.paymentOptions.push(option)
                }
              }

            }

            setPreferedPayments(paymentResponse);

          }
        }, () => {
  
        })
      }
    }, [open]);
    const handleChange = (event, newValue) => {
      setValue(newValue);
      if(newValue == 1){
        // const el = document.createElement('div');
        // el.setAttribute('id', 'pay-nb');
        // let input = document.createElement("input");
        // input.setAttribute('id', 'netbanking-value');
        // input.setAttribute('type', 'text');
        // input.setAttribute('data-netbanking-code', null);
        // el.appendChild(input);
      }
      if(newValue == 0){

      }
    };
    const handleClose = ()=>{
      clearInterval(statusIntervel);
      clearTimeout(upiTimeOut);
      if(onClose)
        onClose()
    }
    const handleConfirm = ()=>{
      if(onConfirm)
        onConfirm()
    }
    const validateUPI = (upi,pay)=>{
      if(upi){
        dispatchValidatePayment({
          "orderId": cashFreeOrderDataState.orderId,
          "multiPaymentDetails":[{
              amount:orderRequestDataState.orderAmount,
              "paymentMode": "upi",
              "paymentView": "web_v2",
              "returnUrl": cashFreeOrderDataState && cashFreeOrderDataState.orderId && orderRequestDataState && orderRequestDataState.returnUrl?orderRequestDataState.returnUrl:'',
              "paymentDetails":{
                "upi": upi,
                'appName':'Add New UPI ID',
              }
          }]
      }, (response) => {
          if (response && response.status && response.status.code == 200 && response.response) {
            setTokenData(response.response);
            setAddUpiError(false);
            setErrorTxt(null);
            handlePay('upi-collect',response.response);
          }else if (response && response.status && response.status.code != 200 &&  response.status.message) {
            setAddUpiError(true);
            setErrorTxt("Enter a Valid UPI id")
          }
        }, () => {
  
        })
      }
    }
    const validateUPIPrefered = (upi,pay)=>{
      if(upi){
        dispatchValidatePayment({
          "orderId": cashFreeOrderDataState.orderId,
          "multiPaymentDetails":[{
              amount:orderRequestDataState.orderAmount,
              "paymentMode": "upi",
              "paymentView": "web_v2",
              "returnUrl": cashFreeOrderDataState && cashFreeOrderDataState.orderId && orderRequestDataState && orderRequestDataState.returnUrl?orderRequestDataState.returnUrl:'',
              "paymentDetails":{
                "upi": upi,
                'appName':selectedUpiValue&&selectedUpiValue =='add'?'Add New UPI ID':'upi',
              }
          }]
      }, (response) => {
          if (response && response.status && response.status.code == 200 && response.response) {
            setTokenData(response.response);
            setAddUpiError(false);
            setErrorTxt(null);
            handlePay('upi-collect',response.response);
          }else if (response && response.status && response.status.code != 200 &&  response.status.message) {
            if(selectedUpiValue&&selectedUpiValue =='add'){
              setAddUpiError(true);
              setErrorTxt("Enter a Valid UPI id")
            }
          }
        }, () => {
  
        })
      }
    }
    const onSelectUPI = (upi,pay)=>{
      setTokenData(null)
      setAddUpiValue(upi)
      /*if(upi){
        dispatchValidatePayment({
          "orderId": cashFreeOrderDataState.orderId,
          "multiPaymentDetails":[{
              amount:orderRequestDataState.orderAmount,
              "paymentMode": "upi",
              "paymentView": "web_v2",
              "returnUrl": cashFreeOrderDataState && cashFreeOrderDataState.orderId && orderRequestDataState && orderRequestDataState.returnUrl?orderRequestDataState.returnUrl:'',
              "paymentDetails":{
                "upi": upi,
                'appName':'Add New UPI ID',
              }
          }]
      }, (response) => {
          if (response && response.status && response.status.code == 200 && response.response) {
            setTokenData(response.response);
          }
        }, () => {
  
        })
      }*/
    }
    const reIntiatePayment = ()=>{
      if(orderRequestData&& orderRequestData.payeeType && ['KHATA_SHOP','DRIVER','SUPPLIER'].includes(orderRequestData.payeeType)){
        dispatchGetPaymentInitiate(orderRequestData, (data) => {
          if (data && data.status && data.status.code == 200 && data.response) {
            setCashFreeOrderDataState(data.response)
          }
        },()=>{
  
        })
      }else if(orderRequestData&& orderRequestData.payeeType && orderRequestData.payeeType =='FASTAG'){
        dispatchFastagRechargetLink(orderRequestData, (data) => {
          if (data && data.status && data.status.code == 200 && data.response) {
            setCashFreeOrderDataState(data.response)
          }
        },()=>{
  
        })
      }else if(orderRequestData&& orderRequestData.payeeType && orderRequestData.payeeType =='FUEL_CARD'){
        dispatchRechargeFuelCard(orderRequestData, (data) => {
          if (data && data.status && data.status.code == 200 && data.response) {
            setCashFreeOrderDataState(data.response)
          }
        },()=>{
  
        })
      }
      
    }
    const redirectUrl = ()=>{
      handleClose()
      if(cashFreeOrderDataState && cashFreeOrderDataState.orderId && orderRequestDataState && orderRequestDataState.returnUrl){
        //window.location.replace(`${orderRequestDataState.returnUrl}?order_id=${cashFreeOrderDataState.orderId}`);
        setTimeout(() => {
          window.location.href = `${orderRequestDataState.returnUrl}?order_id=${cashFreeOrderDataState.orderId}`
        }, 50)
      }
    }
    const options = {
      onPaymentSuccess: function(data) {
          redirectUrl()
          /*
          {
              order:{
                      orderId: "some-orderid",
                      orderStatus: "PAID"
              },
              transaction:{
                  txStatus: "SUCCESS,
                  txMsg: "Transaction Message",
                  transactionId: 1232132,
                  transactionAmount: 1.00
              }
          }
          */
      },
      onPaymentFailure: function(data) {
        if(data && data.txMsg && data.transaction.txMsg)
          //sendError(data.transaction.txMsg)
        clearInterval(statusIntervel);
        clearTimeout(upiTimeOut);
        setCashFreeOrderDataState(null);
        setTokenData(null);
        reIntiatePayment();
          //console.log("Failure:", data);
          //redirectUrl();
          /*
          {
              order:{
                      orderId: "some-orderid",
                      orderStatus: "ACTIVE"
              },
              transaction:{
                  txStatus: "FAILED,
                  txMsg: "Transaction Message",
                  transactionId: 1232132,
                  transactionAmount: 1.00
              }
          }
          */
      },
      onError: function(data) {
          if(data && data.message){
            if(data && data.type=="general_error"){
              sendError(value==0?'UPI payment cancelled':' Payment window closed','Cancelled')
            }else{
              sendError(data.message,'Cancelled')
            } 
          }
          clearInterval(statusIntervel);
          clearTimeout(upiTimeOut);
          setCashFreeOrderDataState(null);
          setTokenData(null)
          reIntiatePayment();
          //redirectUrl()
          /*
          {
              message: "Invalid card number"
              paymentMode: "card"
              type: "input_validation_error"
          }
          */
      },
    };  
    const cfCheckout = cashfreeProd.initializeApp(options);
    const getStatus = ()=>{
      if (cashFreeOrderDataState && cashFreeOrderDataState.orderId) {
        dispatchGetPaymentStatus({
            orderId: cashFreeOrderDataState.orderId
        }, (response) => {
            if (response && response.status && response.status.code == 200 && response.response) {
                if (response.response.status == "SUCCESS") {
                  redirectUrl()
                } else {
                }
            }
        }, () => {
        
        })
    }
    }
    const handlePay = (value,data)=>{
      let isUPICollectReady = false;
      function upiCollectHandler(data){
        isUPICollectReady = data.isReadyToPay
      }
      cfCheckout.elements([
        {
                  pay: document.getElementById('pay-collect'),
                  type: 'upi-collect',
                  onChange: upiCollectHandler
        }
      ]);
      if(data && data.cfToken){
        cfCheckout.pay(data.cfToken, value);
        statusIntervel = setInterval(getStatus,2000);
        upiTimeOut = setTimeout(redirectUrl,180000)
      }
    }
    const handleNBChange = (bank)=>{
      setNetbankingValue(bank);
      if(bank && bank.code){
        let nbElement = document.getElementById('netbanking-value');
        if(!nbElement){
          
        }else{
          nbElement.value = bank.code;
        }
      }
    }
    const payNetBanking = async (token)=>{
      await cfCheckout.pay(token, 'netbanking');
    }
    const handleNBPay = ()=>{
      if(netbankingValue&&netbankingValue.code){ 
        dispatchValidatePayment({
          "orderId": cashFreeOrderDataState.orderId,
          "multiPaymentDetails":[{
              amount:orderRequestDataState.orderAmount,
              "paymentMode": "NET_BANKING",
              "paymentView": "web_v2",
              "paymentDetails":{
                'appName':netbankingValue.name,
              }
          }]
      }, (response) => {
          if (response && response.status && response.status.code == 200 && response.response && response.response.cfToken) {
            let netbankingRedy = false;
            function netBankingHandler(data){
              netbankingRedy = data.isReadyToPay
              document.getElementById("onChangeNB").innerHTML = JSON.stringify(data)
            }
            cfCheckout.elements([
              {
                pay: document.getElementById('pay-nb'),
                type: 'netbanking',
                onChange: netBankingHandler
              }
            ]);
            payNetBanking(response.response.cfToken)
          }
        }, () => {
  
        })
      }
    }
    const getTitleBox = ()=>{
      if(orderRequestDataState && orderRequestDataState.payeeId){
        let payTo = orderRequestDataState.finalBank;
        return <>
        <Box component={'div'} display={'flex'} alignItems={'center'} width={'100%'}>
                <Box component={'div'} justifyContent={'center'} className={classes.iconBox} style={{backgroundColor:'#d9efff'}}>
                    {getTypeIcon(orderRequestDataState.payeeType)}
                </Box>
              <Box width={'100%'}>
                  <Typography className={classes.paymentTitle}>{getTypeTitle(orderRequestDataState.payeeType)}</Typography>
                  <Box component={'div'} display={'flex'} alignItems={'center'} width={'100%'}>
                    {payTo && payTo.acc_type && payTo.acc_type=='UPI'?<Typography className={classes.accountNumber}>{payTo.upi_address}</Typography>:
                    <><Typography className={classes.accountNumber}>{payTo && payTo.acc_number?payTo.acc_number:''}</Typography>
                    {/* {payTo && payTo.bank_name && <><FiberManualRecordIcon className={classes.dot} />
                    <Typography className={classes.accountNumber}>{payTo.bank_name}</Typography></>} */}
                    {payTo && payTo.acc_holder_name && <><FiberManualRecordIcon className={classes.dot} />
                    <Typography className={classes.accountNumber}>{payTo.acc_holder_name}</Typography></>}
                    </>}
                    <Typography className={classes.payTo} style={{marginLeft:'auto'}}>Amount&nbsp;:&nbsp;<span className={classes.amountPay}>{numberFormatWithOutSpace(orderRequestDataState.orderAmount)}</span></Typography>
                  </Box>
              </Box>
      </Box>
        </>
      }else if(orderRequestDataState && orderRequestDataState.vehicleId){
        let payTo = orderRequestDataState.finalBank;
        return <>
        <Box component={'div'} display={'flex'} alignItems={'center'} width={'100%'}>
                <Box component={'div'} justifyContent={'center'} className={classes.iconBox} style={{backgroundColor:'#d9efff'}}>
                    {getTypeIcon(orderRequestDataState.payeeType)}
                </Box>
              <Box width={'100%'}>
                  <Typography className={classes.paymentTitle}>Recharge {getTypeName(orderRequestDataState.payeeType)}</Typography>
                  <Box component={'div'} display={'flex'} alignItems={'center'} width={'100%'}>
                    <Typography className={classes.rechargeTo}>{orderRequestDataState && orderRequestDataState.truckInfo&&orderRequestDataState.truckInfo.vehicleNumber?<VehicleNumberFormat value={orderRequestDataState.truckInfo.vehicleNumber} size={16} />:''}</Typography>
                    <Typography className={classes.payTo} style={{marginLeft:'auto'}}>Amount&nbsp;:&nbsp;<span className={classes.amountPay}>{numberFormatWithOutSpace(orderRequestDataState.orderAmount)}</span></Typography>
                  </Box>
              </Box>
      </Box>
        </>
      }else{
        return <Typography>Payment GateWay</Typography>
      }
    }
    const paymentModes = [
      {
        name:'UPI',
        type:'upi',
        visible:true,
        icon:<img src={UPIIcon} width={24} height={24} className={classes.menuIcon} />
      },
      {
        name:'Netbanking',
        type:'netbanking',
        visible:true,
        icon:<NetBanking className={classes.menuIcon} />
      }
    ]
    const getAddNewUPIElements = (expand,select,selected)=>{
      return <>
        <Box display={'flex'} alignItems={'center'} justifyContent={'space-between'} marginBottom={'16px'}>
            <Box display={'flex'} alignItems={'center'}>
              <AddCircleIcon className={selected?classes.addBtnSelected:classes.addBtnNormal} />
              <Typography className={classes.addNewUpiTxt}>Add New UPI ID</Typography>
            </Box>
            {select&& <SelectedIcon className={selected?classes.selected:classes.unselected} />}
        </Box>
        <Box display={'flex'} alignItems={'center'} marginBottom={'16px'}>
            <img src={UPIBanner} />
        </Box>
        {expand && <><Box display={'flex'} alignItems={'center'} marginBottom={'18px'} width={'100%'}>
            <Box component={'div'} width={'100%'}>
              <Typography className={classes.label}>UPI ID*</Typography>
              <TextField
                className={classes.inputUpi}
                error={addUpiError}
                fullWidth={true}
                required={true}
                onChange={(e)=>{
                  setAddUpiValue(e.target.value);
                  if(e&&e.target&&e.target.value && UPITest(e.target.value)){
                    setAddUpiError(false);
                    setErrorTxt(null)
                  }
                }}
                FormHelperTextProps={{
                  className:classes.helperText
                }}
                onBlur={(e)=>{
                  if(e&&e.target&&e.target.value && !UPITest(e.target.value)){
                    setAddUpiError(true);
                    setErrorTxt("Enter a Valid UPI id")
                  }else{
                    setAddUpiError(false);
                    setErrorTxt(null)
                  }
                }}
                /*inputProps={{
                  'data-upi-id':''
                }}*/
                placeholder='eg: 8116784756@ybl'
                //defaultValue="eg: 8116784756@ybl"
                helperText={addUpiError?errorTxt:'UPI ID is in the format of ‘mobilenumber@bank’ or ‘username@bank’'}
                variant="outlined"
              />
            </Box>
            {/* <Button disabled={addUpiValue&&UPITest(addUpiValue)?false:true} onClick={()=>{validateUPI(addUpiValue)}} className={selected?classes.verifyAddBtnSelected:classes.verifyAddBtn} variant="contained">
              {selected?'verify & Add':'Verify'}
            </Button> */}
        </Box>
        <Box display={'flex'} alignItems={'center'} marginLeft={'-7px'}>
          <img src={UPILogo} width={64} height={40} style={{marginRight:8}} />
          <a className={classes.knowToFind} href={configInfo&&configInfo.howUpiWorks?configInfo.howUpiWorks:'#'} target='_blank'>Know how to find UPI ID</a>
          <NavigateNextIcon className={classes.nextIcon}  />
        </Box></>}
      </>
    }
    const getPaymentBox = (mode)=>{
      if(mode && mode.type && mode.type=='upi'){
        let upiList = preferedPayments && preferedPayments.preferredPaymentOptions && preferedPayments.preferredPaymentOptions.length>0?preferedPayments.preferredPaymentOptions.filter((po)=>po&&po.type&&po.type=='UPI'):[]
        if(upiList.length <=0 && preferedPayments && preferedPayments.addNewUPI){
          return <Box id="pay-collect" display={'flex'} flexDirection={'column'} justifyContent={'space-between'} height={'426px'}>
                  <Box component={'div'} className={classes.addNewUPIBox}>
                  {getAddNewUPIElements(true)}
                </Box>
                <input style={{  visibility: 'hidden'}}  type="text" value={addUpiValue?addUpiValue:''} data-upi-id /> 
                <Button id="pay-collect-btn" onClick={()=>{validateUPI(addUpiValue)}} disabled={addUpiValue&&UPITest(addUpiValue)?false:true} className={classes.payBtn} variant="contained">
                Verify & Pay&nbsp;{numberFormatWithOutSpace(orderRequestDataState&&orderRequestDataState.orderAmount?orderRequestDataState.orderAmount:0)}
                </Button>
          </Box>   
        }else{
          let addselected = selectedUpiValue =='add'?true:false
          return <Box id="pay-collect" display={'flex'} flexDirection={'column'} justifyContent={'space-between'} height={'426px'}>
                  <Box display={'flex'} flexDirection={'column'}>
                    {upiList&&upiList.map((upi)=>{
                      let selected = upi && upi.vpa && upi.vpa ==selectedUpiValue?true:false;
                      return <Box component={'div'} onClick={()=>{setSelectedUpiValue(upi.vpa);onSelectUPI(upi.vpa)}} className={selected?classes.UPIListBoxSelected:classes.UPIListBox} display={'flex'} alignItems={'center'} justifyContent={'space-between'}>
                          <Box display={'flex'} alignItems={'center'}>
                            {upi&&upi.logo_url&&<img src={upi.logo_url} style={{marginRight:16}} />}
                            <Typography className={classes.vpa}>{upi.vpa}</Typography>
                          </Box>
                          <Box display={'flex'} alignItems={'center'} justifyContent={'end'}>
                            <SelectedIcon className={selected?classes.selected:classes.unselected} />
                          </Box>
                      </Box>
                    })}
                    <Box component={'div'} style={{cursor:'pointer'}} className={addselected?classes.addNewUPIBoxSelected:classes.addNewUPIBox} onClick={()=>{setAddUpiValue(null);setSelectedUpiValue('add');setTokenData(null)}}>
                      {getAddNewUPIElements(addselected,true,addselected)}
                    </Box>
                  </Box>
                  <input style={{  visibility: 'hidden'}}  type="text" value={addselected && addUpiValue?addUpiValue:selectedUpiValue?selectedUpiValue:''} data-upi-id /> 
                  <Button id="pay-collect-btn" onClick={()=>{validateUPIPrefered(addUpiValue)}} disabled={addUpiValue&&UPITest(addUpiValue)?false:true} className={classes.payBtn} variant="contained">
                  Verify & Pay&nbsp;{numberFormatWithOutSpace(orderRequestDataState&&orderRequestDataState.orderAmount?orderRequestDataState.orderAmount:0)}
                  </Button>
            </Box>
        }
        
      }else if(mode && mode.type && mode.type=='netbanking'){

        return <Box display={'flex'} flexDirection={'column'} justifyContent={'space-between'} height={'426px'}>
                  <Box component={'div'} id="pay-nb" display={'flex'} flexDirection={'column'}>
                    <Autocomplete
                      id="banklistnb"
                      value={netbankingValue}
                      onChange={(event, newValue) => {
                        handleNBChange(newValue);
                      }}
                      className={classes.inputSelect}
                      getOptionValue={option => option.code}
                      options={preferedPayments && preferedPayments.paymentOptions?preferedPayments.paymentOptions.filter((bank)=>bank&&bank.type&&!(bank.type=='CREDIT_CARD'||bank.type=='DEBIT_CARD')):[]}
                      getOptionLabel={(option) => option.name}
                      style={{ width: '100%',marginBottom:32 }}
                      renderInput={
                        (params) => <TextField 
                        {...params}
                        label={netbankingValue?'':'Select Your Bank'}
                        InputLabelProps={{
                          className:classes.labelSelect
                        }}
                        placeholder='Search for Your Bank' 
                        variant="outlined" />
                      }
                    />
                    <input style={{  visibility: 'hidden'}}  type="text" value={netbankingValue&&netbankingValue.code?netbankingValue.code:''} data-netbanking-code /> 
                    <Grid container justifyContent="center" spacing={2}>
                      {preferedPayments && preferedPayments.paymentOptions&&preferedPayments.paymentOptions.filter((bank)=>bank&&bank.is_recommended).map((bank,key) => {
                        let selected = bank&&netbankingValue&&bank.code&&netbankingValue.code&&bank.code==netbankingValue.code;
                        return (
                        <Grid key={key} item className={classes.nbItem}>
                          <Box className={selected?classes.nbBoxSelected:classes.nbBox} display={'flex'} alignItems={'center'} onClick={()=>{handleNBChange(bank)}} >
                              {bank&&bank.logo_url&&<img src={bank.logo_url} width={24} height={24} style={{marginRight:8}} />}
                              <Typography className={classes.bankName}>{bank&&bank.name?bank.name:''}</Typography>
                              <SelectedIcon className={selected?classes.selected:classes.unselected} style={{marginLeft:'auto'}} />
                          </Box>
                        </Grid>
                      )})}
                    </Grid>
                  </Box>
                  <Button id="pay-nb-btn" onClick={()=>{handleNBPay()}} disabled={netbankingValue&&netbankingValue.code?false:true} className={classes.payBtn} variant="contained">
                    Pay&nbsp;{numberFormatWithOutSpace(orderRequestDataState&&orderRequestDataState.orderAmount?orderRequestDataState.orderAmount:0)}
                  </Button>
        </Box>
      }
    }
    return (
        <>
            <Dialog fullWidth={true}
                maxWidth='md'
                onClose={handleClose} 
                disableEscapeKeyDown={true} 
                disableBackdropClick={true} 
                aria-labelledby="custom-payment-gateway-dialog" 
                open={dialogOpen} 
                classes={{ paper: classes.paper }}>
                <DialogTitle className={classes.dialogTitle}>
                    {getTitleBox()}
                    <IconButton aria-label="close" className={classes.closeButton} onClick={handleClose}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                {/* <Divider /> */}
                <DialogContent className={classes.dialogContent}>
                  {/* <Box component={'div'}  className={classes.payFromWalletBox}>
                    <FormControlLabel
                      control={<BlueCheckbox name="payFromWallet" />}
                      label={<Box component={'div'} display={'flex'} alignItems={'center'}>
                              <PayWalletGeteWayIcon className={classes.walletIcon} />
                              <Box marginLeft={'16px'}>
                                  <Typography className={classes.walletPaymentTitle}>Pay Driver</Typography>
                                  <Typography className={classes.payByWallet}>Wallet Balance:&nbsp;<span className={classes.amountPay}>{numberFormatWithOutSpace(1000)}</span></Typography>
                              </Box>
                      </Box>}
                    />
                  </Box> */}
                  <Box component={'div'}  className={classes.paymentBox}>
                    <PaymentTabs
                      orientation="vertical"
                      variant="scrollable"
                      value={value} 
                      onChange={handleChange} 
                      aria-label="dweb-payment-gateway-payment-tabs"
                    >
                      {paymentModes && paymentModes.map((mode,index)=>{
                        return <PaymentTab label={
                          <Box display={'flex'} alignItems={'center'}>
                            {mode.icon}
                            <Typography>{mode.name}</Typography>
                          </Box>
                        } {...a11yProps(index)} />
                      })}
                    </PaymentTabs>
                    {paymentModes && paymentModes.map((mode,index)=>{
                        return <TabPanel value={value} index={index}>
                          {getPaymentBox(mode)}
                      </TabPanel>
                    })}
                  </Box>
                </DialogContent>
            </Dialog>
        </>
    )
}

const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({
  dispatchFetchPaymentModes: (data, onSuccess, onFailure) => (dispatch(GetPreferedPaymentModes(data, onSuccess, onFailure))),
  dispatchValidatePayment: (data, onSuccess, onFailure) => (dispatch(ValidateThePayment(data, onSuccess, onFailure))),
  dispatchGetPaymentStatus: (data, onSuccess, onError) => {
      dispatch(getPaymentStatusV1(data, onSuccess, onError))
  },
  dispatchFastagRechargetLink: (data, onSuccess, onFailure) => (dispatch(getRechargeLink(data, onSuccess, onFailure))),
  dispatchRechargeFuelCard: (data, onSuccess, onError) => {
    dispatch(rechargeFuelCard(data, onSuccess, onError))
  },  
  dispatchGetPaymentInitiate: (data, onSuccess, onFailure) => (dispatch(getPaymentInitiate(data, onSuccess, onFailure))),
});
export default connect(mapStateToProps, mapDispatchToProps)(DwebPaymentGateWayDialog);